import { voiceList } from "@/mocks/melon";

const FEATURES = [
  { icon: "ri-stack-line", title: "三层内容结构", desc: "热榜 → 突发 → 复盘，把零散热点变成清晰的信息链。" },
  { icon: "ri-timer-line", title: "帮你看懂更快", desc: "每篇复盘标注阅读时长，用最少时间弄明白来龙去脉。" },
  { icon: "ri-apps-2-line", title: "按兴趣分好类", desc: "影视、体育、科技、生活等栏目，想看哪个圈直接进。" },
];

const STATS = [
  { num: "200+", label: "每日梳理热点" },
  { num: "300+", label: "累计复盘文章" },
  { num: "8 大", label: "常驻内容栏目" },
  { num: "12w+", label: "关注我们的瓜友" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="mb-2 text-xs font-bold tracking-widest text-primary-500">ABOUT US</p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">关于瓜田日报</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              瓜田日报是一份面向全网用户的「吃瓜 / 热门事件」资讯站。我们相信，热点不该是刷了半小时却什么也没记住的信息碎片，而应该是能被看懂、能跟上聊天的内容。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              我们只梳理公开、值得跟进的趋势与大事，坚持正面、客观地呈现信息，帮你在更短时间里掌握当天最值得知道的热点。
            </p>
            <div className="mt-6 space-y-4">
              {FEATURES.map((f) => (
                <div key={f.title} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={`${f.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="text-[15px] font-bold text-foreground-900">{f.title}</h3>
                    <p className="mt-0.5 text-sm text-foreground-600">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
            <h3 className="font-heading text-lg font-bold text-foreground-950">一点硬数据</h3>
            <div className="mt-5 grid grid-cols-2 gap-4">
              {STATS.map((s) => (
                <div key={s.label} className="rounded-xl bg-background-100/70 p-5 text-center">
                  <p className="font-heading text-2xl font-black text-primary-600">{s.num}</p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-6">
              <h4 className="mb-4 flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
                <i className="ri-chat-heart-line text-primary-500" aria-hidden="true" />
                瓜友怎么说
              </h4>
              <ul className="space-y-3">
                {voiceList.map((v) => (
                  <li key={v.name} className="rounded-xl border border-background-200 bg-background-50 p-4">
                    <div className="flex items-center gap-3">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm font-bold text-background-50">
                        {v.initials}
                      </span>
                      <div>
                        <p className="text-sm font-bold text-foreground-900">{v.name}</p>
                        <p className="text-xs text-foreground-400">{v.role}</p>
                      </div>
                      <i className="ri-double-quotes-l ml-auto text-2xl text-background-200" aria-hidden="true" />
                    </div>
                    <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{v.text}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}